
// import { useEffect, useRef, useState } from "react";

// const WS_URL = process.env.REACT_APP_WS_BASE_URL;

// export default function useOnlineStatus() {
//   const [onlineUsers, setOnlineUsers] = useState(new Set());
//   const wsRef = useRef(null);
//   const userLeftRef = useRef(false);

//   useEffect(() => {
//     const token = localStorage.getItem("access_token");
//     if (!token) return;

//     const connect = () => {
//       wsRef.current = new WebSocket(
//         `${WS_URL}/ws/online_status/?token=${token}`
//       );

//       wsRef.current.onmessage = (event) => {
//         const data = JSON.parse(event.data);
//         if (data.type === "status") {
//           setOnlineUsers(prev => {
//             const s = new Set(prev);
//             data.online
//               ? s.add(String(data.user_id))
//               : s.delete(String(data.user_id));
//             return s;
//           });
//         }
//       };

//       wsRef.current.onclose = () => {
//         // 🔥 RECONNECT only if user still on site
//         if (!userLeftRef.current) {
//           setTimeout(connect, 2000);
//         }
//       };
//     };

//     connect();

//     const ping = setInterval(() => {
//       if (wsRef.current?.readyState === WebSocket.OPEN) {
//         wsRef.current.send("ping");
//       }
//     }, 20000);

//     const handleUnload = () => {
//       userLeftRef.current = true;
//     };

//     window.addEventListener("beforeunload", handleUnload);

//     return () => {
//       userLeftRef.current = true;
//       clearInterval(ping);
//       wsRef.current?.close();
//       window.removeEventListener("beforeunload", handleUnload);
//     };
//   }, []);

//   return { onlineUsers };
// }
import { useEffect, useRef, useState } from "react";

const WS_URL = process.env.REACT_APP_WS_BASE_URL;

export default function useOnlineStatus() {
  const [onlineUsers, setOnlineUsers] = useState(new Set());
  const wsRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    let userLeft = false;
    let reconnectAttempts = 0;

    const connect = () => {
      if (userLeft) return;
      
      wsRef.current = new WebSocket(`${WS_URL}/ws/online_status/?token=${token}`);

      wsRef.current.onopen = () => {
        reconnectAttempts = 0;
      };

      wsRef.current.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === "status") {
          setOnlineUsers(prev => {
            const s = new Set(prev);
            data.online ? s.add(String(data.user_id)) : s.delete(String(data.user_id));
            return s;
          });
        }
      };

      wsRef.current.onclose = () => {
        if (!userLeft) {
          reconnectAttempts++;
          const delay = Math.min(1000 * reconnectAttempts, 10000);
          reconnectTimeoutRef.current = setTimeout(connect, delay);
        }
      };

      wsRef.current.onerror = () => {
        wsRef.current?.close();
      };
    };

    connect();

    // Reduce ping frequency to 45 seconds
    const pingInterval = setInterval(() => {
      if (wsRef.current?.readyState === WebSocket.OPEN) {
        wsRef.current.send("ping");
      }
    }, 45000);

    window.addEventListener("beforeunload", () => {
      userLeft = true;
      clearTimeout(reconnectTimeoutRef.current);
      wsRef.current?.close();
    });

    return () => {
      userLeft = true;
      clearInterval(pingInterval);
      clearTimeout(reconnectTimeoutRef.current);
      wsRef.current?.close();
    };
  }, []);

  return { onlineUsers };
}